<script setup lang="ts">
import DefaultWidgetView from '@components/widget/defaultWidgetView.vue'

defineProps<{
  items: Array<{
    Uuid?: string
    Bundle?: { Uuid: string }
    Name?: string
    FIO?: string
  }>
  readonly: boolean
}>()

const emit = defineEmits(['removeItem'])
</script>

<template>
  <DefaultWidgetView
    :items="items"
    :readonly="readonly"
    route="factor"
    @remove-item="emit('removeItem', $event)"
  />
</template>
